import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthCallbackPage } from '@/pages/auth/callback/authCallbackPage';

interface AuthCallbackSearch {
  code: string;
  state: string;
}

// Deliberately no createAuthGuard here: a stale stored token would bounce the
// user into the app mid-exchange, abandoning the single-use OIDC code + state.
export const Route = createFileRoute('/auth/callback')({
  validateSearch: (search: Record<string, unknown>): AuthCallbackSearch => ({
    code: typeof search.code === 'string' ? search.code : '',
    state: typeof search.state === 'string' ? search.state : ''
  }),
  beforeLoad: ({ search }) => {
    if (!search.code || !search.state) {
      throw redirect({ to: '/login' });
    }
  },
  component: AuthCallbackRouteComponent
});

function AuthCallbackRouteComponent() {
  const { code, state } = Route.useSearch();
  return <AuthCallbackPage code={code} state={state} />;
}
